"use client"

import { SigninForm } from "@/components/signin-form"
import { clearAuthSession, isAuthenticated } from "@/lib/auth"
import { useParams, useRouter } from "next/navigation"
import { useEffect, useState } from "react"
import { Spinner } from "@/components/ui/spinner"

export default function LoginPage() {
  const router = useRouter()
  const params = useParams()
  const locale = (params?.locale as string) || "pt-BR"
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    let cancelled = false

    const confirmSession = async () => {
      if (!isAuthenticated()) {
        if (!cancelled) setChecked(true)
        return
      }

      try {
        const res = await fetch("/api/otp/session", {
          credentials: "include",
          cache: "no-store",
        })
        const data = (await res.json().catch(() => ({}))) as { valid?: boolean }
        if (cancelled) return
        if (data.valid) {
          router.replace(`/${locale}/panel`)
          return
        }
      } catch {
        // Stale localStorage without a live OTP cookie — stay on login.
      }

      if (cancelled) return
      await fetch("/api/otp/logout", { method: "POST" }).catch(() => undefined)
      clearAuthSession()
      setChecked(true)
    }

    void confirmSession()
    return () => {
      cancelled = true
    }
  }, [locale, router])

  if (!checked) {
    return (
      <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
        <Spinner className="size-6" />
      </div>
    )
  }

  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">
        <SigninForm />
      </div>
    </div>
  )
}

